import React from 'react';
import {
  MobileDrawer,
  Card,
  IconButton,
  MobileDrawerPosition,
} from 'wix-ui-tpa/cssVars';
import Text, { TextType } from '../../../Text/Text';
import { ModalContent } from '../ModalContent/ModalContent';
import { ButtonProp, ModalFooter } from '../ModalFooter/ModalFooter';
import { classes, st } from './MobileModal.st.css';
import { Close } from '@wix/wix-ui-icons-common/on-stage';
import { MobileModalDataHooks } from './dataHooks';
import { CartModalDataHooks } from '../dataHooks';
import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import { ServiceData } from '../../../../../utils/state/types';
import { FormSelectedSlot } from '../../../../../types/formSelectedSlots';
import { useFormComponentContext } from '../../../Hooks/useFormComponentContext';

export interface MobileModalProps {
  serviceData: ServiceData;
  formSelectedSlot: FormSelectedSlot;
  dataHook: string;
  primaryButton?: ButtonProp;
  secondaryButton?: ButtonProp;
  isOpen: boolean;
  onClose: () => {};
  onOverlayClose: () => {};
  title: string;
}

export const MobileModal: React.FC<MobileModalProps> = ({
  formSelectedSlot,
  serviceData,
  primaryButton,
  secondaryButton,
  isOpen,
  onClose,
  onOverlayClose,
  title,
  dataHook,
}) => {
  const { isRTL } = useEnvironment();
  const { isUpsellPluginInstalled } = useFormComponentContext();
  const { t } = useTranslation();

  return (
    <MobileDrawer
      isFullScreen={isUpsellPluginInstalled}
      data-hook={dataHook}
      isOpen={isOpen}
      className={st(classes.root, {
        rtl: isRTL,
        fullscreen: !!isUpsellPluginInstalled,
      })}
      onRequestClose={onOverlayClose}
      position={MobileDrawerPosition.Bottom}
    >
      <IconButton
        data-hook={MobileModalDataHooks.CLOSE_BUTTON}
        icon={<Close />}
        className={classes.closeButton}
        onClick={onClose}
        aria-label={t(
          'app.bookings-form.add-to-cart-modal.close-button.aria-label',
        )}
      />
      <Card stacked className={classes.contentWrapper}>
        <Card.Container>
          <Text
            type={TextType.Title}
            className={classes.title}
            data-hook={CartModalDataHooks.TITLE}
          >
            {title}
          </Text>
          <div className={classes.contentContainer}>
            <ModalContent
              formSelectedSlot={formSelectedSlot}
              serviceData={serviceData}
            />
          </div>
        </Card.Container>
        <Card.Container
          className={[
            classes.footerWrapper,
            ...(isUpsellPluginInstalled ? [classes.footerMargin] : []),
          ].join(' ')}
        >
          <ModalFooter
            primaryButton={primaryButton}
            secondaryButton={secondaryButton}
          />
        </Card.Container>
      </Card>
    </MobileDrawer>
  );
};
